import styled from 'styled-components';

import { rem } from '../../../utils';

export const StyledPostTabContainer = styled.div`
  height: 100%;
  border-left: 1px solid ${({ theme }) => theme.Color.Neutrals.Border};
`;

export const StyledDropdownButton = styled.button`
  display: flex;
  align-items: center;
  height: 100%;
  border: none;
  border-radius: 0 ${({ theme }) => rem(theme.Border.Radius.Small)}
    ${({ theme }) => rem(theme.Border.Radius.Small)} 0;
  cursor: pointer;
  background: ${({ theme }) => theme.Color.Neutrals.Light};
  padding: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
`;
